import React from 'react';
import { Slider } from "antd";
import {
SliderComp,
TabTitles,
TextWrapper,
Reset,
MinMaxWrap,
Min,
Max
} from "./styles";
import { recordError } from '../../../../utils/commonUtil';
import PropTypes from 'prop-types';

export default class FilterSlider extends React.Component{
state={
  value:[this.props.minValue,this.props.maxValue],
  disabled:true
}
onAfterChange = value => {
  this.setState({ value: value });

    this.props.slideValues(value, this.props.max);
  
  
};

filterReset = () => { 
  let valueArr = [this.props.min, this.props.max];
  this.setState({value: [this.props.min,this.props.max]})
  this.props.slideValues(valueArr, this.props.max);
};

componentWillReceiveProps(nextProps) {
  if (nextProps.maxValue === nextProps.max && nextProps.minValue === nextProps.min) {
  this.setState({ value: [0, this.props.max] })}
  }
  
  handleEnabledChange = () => {
    try {
      this.setState({ disabled:false },this.props.sliderStatus(this.state.disabled));
    } catch (error) {
      recordError(error);
    }
  };
  handleDisabledChange = () => {
    try {
      this.setState({ disabled:true },this.props.sliderStatus(this.state.disabled));
      this.filterReset()
    } catch (error) {
      recordError(error);
    }
  };

  enableEmp = value=>{
 if(value){
   return(<Reset className="pointer"  onClick={this.handleEnabledChange}>Enable</Reset>)
 }
 else{
   return(<Reset onClick={this.handleDisabledChange} className="pointer">Reset</Reset>)
 }
  }


render() {
return (
<SliderComp>
<TextWrapper>
<TabTitles>{this.props.title}</TabTitles>
{this.props.setDisable? this.enableEmp(this.state.disabled)
:(<Reset onClick={this.filterReset} className="pointer">Reset</Reset>)}

</TextWrapper>
{this.props.setDisable ?(<Slider
range
min={this.props.min}
max={this.props.max}
step={1}
value={this.state.disabled?[0, 3500]:this.state.value}
onChange={this.onAfterChange}
onAfterChange={this.onAfterChange}
key={this.props.title}
tipFormatter={this.props.tipFormatter}
disabled={this.state.disabled}
/>):(<Slider
range
min={this.props.min}
max={this.props.max}
step={1}
value={this.state.value}
onChange={this.onAfterChange}
onAfterChange={this.onAfterChange}
key={this.props.title}
tipFormatter={this.props.tipFormatter}
/>)}

<MinMaxWrap>
<Min>Min</Min>
<Max>Max</Max>
</MinMaxWrap>
</SliderComp>
);
}
};


FilterSlider.propTypes = {
  max: PropTypes.number,
  maxValue: PropTypes.number,
  min: PropTypes.number,
  minValue: PropTypes.number,
  setDisable: PropTypes.bool,
  slideValues: PropTypes.func,
  sliderStatus: PropTypes.func,
  tipFormatter: PropTypes.any,
  title: PropTypes.string
}